import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../../components/Button';

export const StyledProgressBar = styled.div<{ progressPercentage: number }>`
  width: 100%;
  height: 8px;
  background-color: ${colorsPalettes.carbon[50]};
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  margin-bottom: 16px;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${({ progressPercentage }) => progressPercentage}%;
    height: 100%;
    background-color: ${colorsPalettes.blue[500]};
    transition: width 0.5s ease-in-out;
    border-radius: 10px;
  }
`;

export const StyledCloseButton = styled(Button)`
  background-color: transparent;
  padding: 8px;
  svg path {
    fill: ${colorsPalettes.carbon[300]};
  }
`;

export const StyledStepsCounter = styled.div`
  margin-left: auto;
  ${setFontVariant('report', colorsPalettes.carbon[200])};
  line-height: 18px;
  display: inline-flex;
  align-items: center;

  span {
    font-weight: 700;
    color: ${colorsPalettes.carbon[300]};
  }
`;

export const StyledOnboardingStepTitle = styled.h2`
  ${setFontVariant('h4', colorsPalettes.carbon[500])};
  width: 100%;
  margin: 24px 0 8px 0;
`;

export const StyledOnboardingStepSubtitle = styled.p`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  line-height: 20px;
  margin: 0 0 16px 0;
`;
